import type { ReactNode } from 'react'
import React from 'react'
import useContainerWidth from './useContainerWidth'

type AtWidthSizes = {
  /** Content to show on the smallest of widths */
  default?: ReactNode

  /** Content to show if width > 250px */
  nano?: ReactNode

  /** Content to show if width > 320px */
  xxs?: ReactNode

  /** Content to show if width > 380px */
  xs?: ReactNode

  /** Content to show if width > 470px */
  sm?: ReactNode

  /** Content to show if width > 600px */
  md?: ReactNode

  /** Content to show if width > 750px */
  lg?: ReactNode

  /** Content to show if width > 950px */
  xl?: ReactNode

  /** Content to show if width > 1200px */
  xxl?: ReactNode
}

type AtContainerWidthProps = {
  children: (atWidth: ReturnType<typeof useContainerWidth>) => JSX.Element
}

const AtContainerWidth = ({ children }: AtContainerWidthProps): JSX.Element => children(useContainerWidth())

export default AtContainerWidth

// This is only used to display the different sizes values in storybook
export const AtWidthProps = ({
  default: defaultValue,
  nano,
  xxs,
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
}: AtWidthSizes): JSX.Element => <div>{[defaultValue, nano, xxs, xs, sm, md, lg, xl, xxl]}</div>
